import { useAuth } from "@/hooks/useAuth";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";

/**
 * Renders a "you'll be signed out soon" dialog 60 seconds before the
 * 30-minute HIPAA inactivity timeout fires. Mounted once at the App root
 * so it's available on every authenticated route.
 */
export default function InactivityWarning() {
  const { inactivityWarningSeconds, dismissInactivityWarning, signOut, user } = useAuth();
  const open = !!user && inactivityWarningSeconds !== null;

  return (
    <AlertDialog open={open}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Are you still there?</AlertDialogTitle>
          <AlertDialogDescription>
            For your clients' security, we'll sign you out in{" "}
            <span className="font-semibold text-foreground">
              {inactivityWarningSeconds ?? 0} seconds
            </span>{" "}
            due to inactivity.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={() => signOut()}>Sign out now</AlertDialogCancel>
          <AlertDialogAction onClick={dismissInactivityWarning}>Stay signed in</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
